import React, { useEffect, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { useDispatch } from "react-redux"
import { updatePaymentGarage} from "../../../store/action/payment";
import {translateReplacementCarStatus} from "../../../utils/translateReplacementCarStatus";
import { CompleteMissionRGA} from "../../../store/action/wsPI.js";
import * as Actions from "../../../store/action/payment.js";  
const useStyles = makeStyles((theme) => ({
    card: {  
        backgroundColor: 'white',
        borderRadius: '8px', 
        width:"100%", 
        height:"680px",  
        border: '0.61px solid rgba(226, 217, 239, 1)', 
    },
    cardTitle: {
        fontFamily: 'Poppins',
        fontSize: '18px',
        fontWeight: 500,
        LineHeight :'21px',
        marginBottom: '20px', 
    },
    cardText: {
        fontFamily: 'Poppins',
        fontSize: '13px',
        fontWeight: 500, 
        color: 'rgba(128, 128, 143, 1)', 
    },
    cardValue: {
        fontFamily: 'Poppins',
        fontSize: '13px',
        fontWeight: 500,
        color: 'rgba(24, 28, 50, 1)',
        textAlign : 'Right', 
    },
    styleInput : {
        fontFamily: 'Poppins',
        fontSize: '13px',
        fontWeight: 500,
        border : 0,
        background: "rgba(243, 246, 249, 1)", 
        color: 'rgba(24, 28, 50, 0.58)',
        lineHeight : '21px' , 
        textAlign : 'Right',
        padding : '5px',
        Width :'209px',
        Height :'28px',
        borderRadius:'4px'
    },
    styleTextArea : {
        fontFamily: 'Poppins',
        fontSize: '13px',
        fontWeight: 500,
        border : "1px solid rgba(0, 0, 0, 0.2)",
        background: "rgba(255, 255, 255, 1)", 
        color: 'rgba(24, 28, 50, 0.58)',
        lineHeight : '21px' ,  
        padding : '5px',
        minWidth :'305px',
        minHeight :'77px',
        borderRadius:'4px',
        resize: 'none',
    },
    TextContainer: {
        display: 'flex',
        justifyContent: 'space-between', 
        margin : '10px 15px', 
    },
    buttonContainer: {
        display: 'flex',
        justifyContent: 'end', 
        alignItems: 'center',
        height:"48px" ,
        background:"rgba(244, 244, 244, 1)" ,
        borderBottomLeftRadius:'12px',
        borderBottomRightRadius:'12px'
        
    },
    annulerStyle: { 
        width: '100px', height: '35px',
        backgroundColor: 'rgba(255, 229, 229, 1)', 
        marginRight : '20px',
        borderRadius:'5.38px',
        fontFamily: 'Poppins',
        fontSize: '10.76px',
        fontWeight: 600,
        color:'rgba(255, 54, 54, 1)',
        border : 0,
    },
    valideStyle: { 
       width: '100px', height: '35px',
        backgroundColor: 'rgba(60, 101, 86, 1)',
        color: 'rgba(255, 255, 255, 1)', 
        marginRight : '20px',
        borderRadius:'5.38px',
        fontFamily: 'Poppins',
        fontSize: '10.76px',
        fontWeight: 600, 
        border : 0,
    }


}));

const RegulationsGarage = ({ isTaskClaimed , data , setAction , actionPI}) => {
    const classes = useStyles();
     const dispatch = useDispatch();
    const [honoraireGarage , setHonoraireGarage ] = useState(data);

    const handleInputChange = (event) => {
        const value = event.target.value;
        event.target.value = value.replace(/[^0-9.,]|([,.][0-9]*[,.])/g, '');
      };

    const updateData = (name, value) => { 
        setHonoraireGarage((prev) => ({
            ...prev,
            [name]: value,
        }));
    };

    const handleValider = async () => { 
        honoraireGarage.status ="APPROVED"
        const reponse = await updatePaymentGarage(honoraireGarage);
        setAction(true)
        setHonoraireGarage(reponse)
    };
    const handleRejeter = async () => {
        honoraireGarage.status ="REFUSED"
        const reponse = await updatePaymentGarage(honoraireGarage);
        setAction(true)
        setHonoraireGarage(reponse)
    };

    const sendToPI = async () => {
          console.log("honoraireGarage : " , honoraireGarage)
              let isSuccess = false;
              let message = "";
               
                const res = await CompleteMissionRGA(honoraireGarage);
                console.log("res : ", res.success)
                isSuccess = res.success;
                message = res.message || "";
              const newStatus = isSuccess ? "PIOK" : "PIKO";
              console.log("newStatus : ", newStatus)
              await dispatch(Actions.updatePaymentStatus(honoraireGarage._id, newStatus, message));
              setAction(true)
          }

    return (
        <div className={classes.card}>
            <div style={{overflowX: 'hidden', overflowY: 'auto' , height:"630px",  }}>
            <div className={classes.TextContainer}>
                <div className={classes.cardTitle}>Honoraire Garage</div>

            </div>
            <div className={classes.TextContainer}>
                <div className={classes.cardText}>Status</div>
                <div className={classes.cardValue} style={{ color: 'rgba(255, 168, 0, 1)' }}>{translateReplacementCarStatus(honoraireGarage.status) ||'N/A'}</div>
            </div>
            <div className={classes.TextContainer}>
                <div className={classes.cardText}>Code garage</div>
                <div className={classes.cardValue}>{honoraireGarage.garageCode ||'N/A'}</div>
            </div>
            <div className={classes.TextContainer}>
                <div className={classes.cardText}>Montant Pièces</div>
                <div className={classes.cardValue}><input disabled={isTaskClaimed} 
                    className={classes.styleInput} 
                    type="number"  step="any" min="0"
                    onInput= {handleInputChange} 
                    name="partsAmount" value={honoraireGarage.partsAmount} 
                    onChange={(e) => updateData(e.target.name, e.target.value)}/></div>
            </div>
            <div className={classes.TextContainer}>
                <div className={classes.cardText}>Nombre d’heures</div>
                <div className={classes.cardValue}><input disabled={isTaskClaimed} 
                    className={classes.styleInput} 
                    type="number"  step="any" min="0"
                    onInput= {handleInputChange} 
                    name="totalHours" value={honoraireGarage.totalHours} 
                    onChange={(e) => updateData(e.target.name, e.target.value)}/></div>
            </div>
            <div className={classes.TextContainer}>
                <div className={classes.cardText}>Nombre d’heures t1</div>
                <div className={classes.cardValue}><input disabled={isTaskClaimed} 
                    className={classes.styleInput} 
                    type="number"  step="any" min="0"
                    onInput= {handleInputChange} 
                    name="hoursT1" value={honoraireGarage.hoursT1}  
                    onChange={(e) => updateData(e.target.name, e.target.value)}/></div>
            </div>
            <div className={classes.TextContainer}>
                <div className={classes.cardText}>Nombre d’heures t2</div>
                <div className={classes.cardValue}><input disabled={isTaskClaimed} 
                    className={classes.styleInput} 
                    type="number"  step="any" min="0"
                    onInput= {handleInputChange} 
                    name="hoursT2" value={honoraireGarage.hoursT2}   
                    onChange={(e) => updateData(e.target.name, e.target.value)}/></div>
            </div>
            <div className={classes.TextContainer}>
                <div className={classes.cardText}>Nombre d’heures  peinture</div>
                <div className={classes.cardValue}><input disabled={isTaskClaimed}  
                    className={classes.styleInput} 
                    type="number"  step="any" min="0"
                    onInput= {handleInputChange} 
                    name="paintHours" value={honoraireGarage.paintHours}   
                    onChange={(e) => updateData(e.target.name, e.target.value)}/></div>
            </div>
            <div className={classes.TextContainer}>
                <div className={classes.cardText}>Tarif horaire t1</div>
                <div className={classes.cardValue}> <input disabled={isTaskClaimed} 
                    className={classes.styleInput} 
                    type="number"  step="any" min="0"
                    onInput= {handleInputChange} 
                    name="hourlyRateT1" value={honoraireGarage.hourlyRateT1}  
                    onChange={(e) => updateData(e.target.name, e.target.value)}/></div>
            </div>
            <div className={classes.TextContainer}>
                <div className={classes.cardText}>Tarif horaire t2</div>
                <div className={classes.cardValue}><input disabled={isTaskClaimed}
                    className={classes.styleInput} 
                    type="number"  step="any" min="0"
                    onInput= {handleInputChange} 
                    name="hourlyRateT2" value={honoraireGarage.hourlyRateT2}   
                    onChange={(e) => updateData(e.target.name, e.target.value)}/></div>
            </div>
            <div className={classes.TextContainer}>
                <div className={classes.cardText}>Montant total réparation Sans Tax</div>
                <div className={classes.cardValue}><input disabled={isTaskClaimed} 
                    className={classes.styleInput} 
                    type="number"  step="any" min="0"
                    onInput= {handleInputChange} 
                    name="totalRepairAmountWOTax" value={honoraireGarage.totalRepairAmountWOTax}   
                    onChange={(e) => updateData(e.target.name, e.target.value)}/></div>
            </div>
            <div className={classes.TextContainer}>
                <div className={classes.cardText}>Montant total réparation TTC</div>
                <div className={classes.cardValue}><input disabled={isTaskClaimed}
                    className={classes.styleInput} 
                    type="number"  step="any" min="0"
                    onInput= {handleInputChange} 
                    name="totalRepairAmountWTax" value={honoraireGarage.totalRepairAmountWTax} 
                    onChange={(e) => updateData(e.target.name, e.target.value)}/></div>
            </div>
            <div className={classes.TextContainer}>
                <div className={classes.cardText}>Part STAR sans remise TTC</div>
                <div className={classes.cardValue}><input disabled={isTaskClaimed} 
                    className={classes.styleInput} 
                    type="number"  step="any" min="0"
                    onInput= {handleInputChange} 
                    name="companyShareWODiscountWTax" value={honoraireGarage.companyShareWODiscountWTax}   
                    onChange={(e) => updateData(e.target.name, e.target.value)}/></div>
            </div>
            <div className={classes.TextContainer}>
                <div className={classes.cardText}>Part client TTC</div>
                <div className={classes.cardValue}><input disabled={isTaskClaimed} 
                    className={classes.styleInput} 
                    type="number"  step="any" min="0"
                    onInput= {handleInputChange} 
                    name="clientShareWTax" value={honoraireGarage.clientShareWTax}   
                    onChange={(e) => updateData(e.target.name, e.target.value)}/></div>
            </div>
            <div className={classes.TextContainer}>
                <div className={classes.cardText}>Taux de remise sur les pièces</div>
                <div className={classes.cardValue}><input disabled={isTaskClaimed} 
                    className={classes.styleInput} 
                    type="number"  step="any" min="0"
                    onInput= {handleInputChange} 
                    name="discountRateOnParts" value={honoraireGarage.discountRateOnParts}   
                    onChange={(e) => updateData(e.target.name, e.target.value)}/></div>
            </div>
            <div className={classes.TextContainer}>
                <div className={classes.cardText}>Taux de remise sur la main d’oeuvre</div>
                <div className={classes.cardValue}><input disabled={isTaskClaimed} 
                    className={classes.styleInput} 
                    type="number"  step="any" min="0"
                    onInput= {handleInputChange} 
                    name="discountRateOnLabor" value={honoraireGarage.discountRateOnLabor}   
                    onChange={(e) => updateData(e.target.name, e.target.value)}/></div>
            </div>
            <div className={classes.TextContainer}>
                <div className={classes.cardText}>Montant de remise en Sans Tax</div>
                <div className={classes.cardValue}><input disabled={isTaskClaimed}
                    className={classes.styleInput} 
                    type="number"  step="any" min="0"
                    onInput= {handleInputChange} 
                    name="discountAmountWOTax" value={honoraireGarage.discountAmountWOTax}   
                    onChange={(e) => updateData(e.target.name, e.target.value)}/></div>
            </div>
            <div className={classes.TextContainer}>
                <div className={classes.cardText}>Montant Total de réparation avec remise Sans Tax</div>
                <div className={classes.cardValue}><input disabled={isTaskClaimed}
                    className={classes.styleInput} 
                    type="number"  step="any" min="0"
                    onInput= {handleInputChange} 
                    name="totalRepairAmountWDiscount" value={honoraireGarage.totalRepairAmountWDiscount}   
                    onChange={(e) => updateData(e.target.name, e.target.value)}/></div>
            </div>
            <div className={classes.TextContainer}>
                <div className={classes.cardText}>Part STAR avec remise TTC (A payer)</div>
                <div className={classes.cardValue}><input disabled={isTaskClaimed} 
                    className={classes.styleInput} 
                    type="number"  step="any" min="0"
                    onInput= {handleInputChange} 
                    name="companyShareWithDiscountWTax" value={honoraireGarage.companyShareWithDiscountWTax}   
                    onChange={(e) => updateData(e.target.name, e.target.value)}/></div>
            </div>
            <div className={classes.TextContainer}>
                <div className={classes.cardText}>Numéro facture</div>
                <div className={classes.cardValue}><input disabled={isTaskClaimed} 
                    className={classes.styleInput} 
                    type="text" 
                    name="invoiceNumber" value={honoraireGarage.invoiceNumber}   
                    onChange={(e) => updateData(e.target.name, e.target.value)}/></div>
            </div>
            <div className={classes.TextContainer}>
                <div className={classes.cardText}>Date facture</div>
                <div className={classes.cardValue}><input disabled={isTaskClaimed} 
                    className={classes.styleInput} 
                    type="date" 
                    name="dateOfInvoice"
                    style={{ width: 175  }}  
                    value= {honoraireGarage?.dateOfInvoice ? new Date(honoraireGarage.dateOfInvoice).toISOString().slice(0, 10) : ''}
                    onChange={(e) => updateData(e.target.name, e.target.value)}/></div>
            </div>
            <div className={classes.TextContainer}>
                <div className={classes.cardText}>Beneficiare</div>
                <div className={classes.cardValue}><input disabled={isTaskClaimed} 
                    className={classes.styleInput} 
                    type="text" 
                    name="beneficiary" value={honoraireGarage.beneficiary}   
                    onChange={(e) => updateData(e.target.name, e.target.value)}/></div>
            </div>
            <div className={classes.TextContainer}>
                <div className={classes.cardText}>N°CIN</div>
                <div className={classes.cardValue}><input disabled={isTaskClaimed} 
                    className={classes.styleInput} 
                    type="text" 
                    name="idNumber" value={honoraireGarage.idNumber}   
                    onChange={(e) => updateData(e.target.name, e.target.value)}/></div>
            </div>
            <div className={classes.TextContainer}>
                <div className={classes.cardText}>Délivrée le</div>
                <div className={classes.cardValue}><input disabled={isTaskClaimed} 
                    className={classes.styleInput} 
                    type="date" 
                    name="issuedOn"  
                    style={{ width: 175  }} 
                    value= {honoraireGarage?.issuedOn ? new Date(honoraireGarage.issuedOn).toISOString().slice(0, 10) : ''}
                    onChange={(e) => updateData(e.target.name, e.target.value)}/></div>
            </div>
            <div className={classes.TextContainer}>
                <div className={classes.cardText}>A</div>
                <div className={classes.cardValue}><input disabled={isTaskClaimed} 
                    className={classes.styleInput} 
                    type="text" 
                    name="issuedAt" value={honoraireGarage.issuedAt}   
                    onChange={(e) => updateData(e.target.name, e.target.value)}/></div>
            </div>
            <div className={classes.TextContainer}>
                <div className={classes.cardText}>Responsabilité</div>
                <div className={classes.cardValue}><input disabled={isTaskClaimed} 
                    className={classes.styleInput} 
                    type="text" 
                    name="responsibility" value={honoraireGarage.responsibility}   
                    onChange={(e) => updateData(e.target.name, e.target.value)}/></div>
            </div>
            <div className={classes.TextContainer}>
                <div className={classes.cardText}>Compagnie adverse</div>
                <div className={classes.cardValue}><input disabled={isTaskClaimed} 
                    className={classes.styleInput} 
                    type="text" 
                    name="opposingCompany" value={honoraireGarage.opposingCompany}   
                    onChange={(e) => updateData(e.target.name, e.target.value)}/></div>
            </div>
            <div className={classes.TextContainer}>
                <div className={classes.cardText}>N°Contrat compagnie adverse</div>
                <div className={classes.cardValue}><input disabled={isTaskClaimed} 
                    className={classes.styleInput} 
                    type="text" 
                    name="opposingCompanyPolicyNumber" value={honoraireGarage.opposingCompanyPolicyNumber}   
                    onChange={(e) => updateData(e.target.name, e.target.value)}/></div>
            </div>
            <div className={classes.TextContainer}>
                <div className={classes.cardText}>N°sinistre compagnie adverse</div>
                <div className={classes.cardValue}><input disabled={isTaskClaimed} 
                    className={classes.styleInput} 
                    type="text" 
                    name="opposingCompanyClaimNumber" value={honoraireGarage.opposingCompanyClaimNumber}   
                    onChange={(e) => updateData(e.target.name, e.target.value)}/></div>
            </div>
            {honoraireGarage.motifPI &&<div className={classes.TextContainer}>
                            <div className={classes.cardText}>motif PI</div>
                            <div className={classes.cardValue}>{honoraireGarage.motifPI}</div>
                        </div>}
            <div className={classes.TextContainer}>
                <div className={classes.cardText}>Véhicule compagnie adverse</div>
                <div className={classes.cardValue}><input disabled={isTaskClaimed} 
                    className={classes.styleInput} 
                    type="text" 
                    name="opposingCompanyVehicle" value={honoraireGarage.opposingCompanyVehicle}   
                    onChange={(e) => updateData(e.target.name, e.target.value)}/></div>
            </div>
        </div>
        {isTaskClaimed?<></> : (
                    <div className={classes.buttonContainer}>
                        {actionPI  ? (
                            <button className={classes.valideStyle} onClick={sendToPI}>Envoyer à PI</button>
                        ) :
                         (<>
                         <button className={classes.annulerStyle} onClick={handleRejeter}>Rejeter</button>
                         <button className={classes.valideStyle} onClick={handleValider}>Valider Réglement</button></>)
                        }
                            
                    </div>
                )}

        </div>
            
     
    );
}

export default RegulationsGarage;